import { render, staticRenderFns } from "./BaseLabelWithModeOfTransport.vue?vue&type=template&id=04fb5d46&scoped=true&"
import script from "./BaseLabelWithModeOfTransport.vue?vue&type=script&lang=js&"
export * from "./BaseLabelWithModeOfTransport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fb5d46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
